import Provider from '@/models/Provider'
import Api from '@/services/api'
import { each, find } from 'lodash'
import Form from '@/utils/form'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1
    },
    providerDetails: null,
    form: new Form({
      id: null,
      name: '',
      link: '',
      categories: []
    }),
    templates: []
  },

  mutations: {
    setProviderList(state, providers) {
      each(providers, provider => {
        const exist = find(state.list, { id: provider.id })
        if (!exist) {
          state.list.push(new Provider(provider))
        }
      })
    },

    clearProviderList(state) {
      state.list = []
    },

    setProviderListMeta(state, meta) {
      state.listMeta = meta
    },

    setProviderDetails(state, provider) {
      if (provider instanceof Provider) {
        state.providerDetails = provider
      } else {
        state.providerDetails = new Provider(provider)
      }
    },

    clearProviderDetails(state) {
      state.providerDetails = null
    },

    setTemplates(state, payload) {
      state.templates = payload
    },

    addCategory(state, payload) {
      state.templates.push({ name: payload })
    }
  },

  getters: {
    providerDetails(state) {
      return state.providerDetails
    }
  },

  actions: {
    async getProviders({ commit }, params) {
      const query = Provider.page(params.page || 1)

      if (params.search) {
        query.where('search', params.search)
      }

      if (params.sort) {
        query.orderBy(params.sort)
      }

      if (params.searchDate) {
        query.where('searchDate', params.searchDate)
      }

      if (params.template) {
        query.where('template', params.template)
      }

      const res = await query.params({ limit: 20 }).get()

      commit('setProviderList', res.data)
      commit('setProviderListMeta', res.meta)
    },

    async getProviderDetails({ commit }, id) {
      const { data } = await Api.get(`licence-provider/${id}`)
      commit('setProviderDetails', data.data)
    },

    async createProvider({ commit }, formData) {
      const { data } = await Api.post(`licence-provider`, formData)
      commit('setProviderDetails', data.data)
    },

    async updateProvider({ commit }, formData) {
      const { data } = await Api.put(
        `licence-provider/${formData.id}`,
        formData
      )
      commit('setProviderDetails', data.data)
    },

    async deleteProvider({ commit }, id) {
      const { data } = await Api.delete(`licence-provider/${id}`)
      return data
    },

    async getTemplates({ commit }) {
      const { data } = await Api.get('templates')
      commit('setTemplates', data.data)
    }
  }
}
